import { RestRequest, RestContext, ResponseFunction } from 'msw'
import {
  addToEntityListData,
  updateEntityListData,
  updateEntityListDataMultiple,
  deleteEntityListData,
} from '../../../modules/mockDataCommon'
import { requireAuthenticatedUser } from '../../../decorators'
import { getOpportunityStageListData } from './mockData'
import type { IOpportunityStage } from '~/types/opportunity/models'

// get

interface GetOpportunityStagesResponse {
  data: IOpportunityStage[]
}

async function getOpportunityStages(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  const responseBody: GetOpportunityStagesResponse = {
    data: await getOpportunityStageListData(),
  }
  return res(ctx.status(200), ctx.json(responseBody))
}

// post

const postOpportunityStage = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return addToEntityListData(req, res, ctx, getOpportunityStageListData)
}

const patchOpportunityStage = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return updateEntityListData(req, res, ctx, getOpportunityStageListData)
}

const patchOpportunityStages = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return updateEntityListDataMultiple(
    req,
    res,
    ctx,
    getOpportunityStageListData
  )
}

const deleteOpportunityStage = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return deleteEntityListData(req, res, ctx, getOpportunityStageListData)
}

export const handlers = [
  {
    method: 'get',
    path: '/api/opportunitystages',
    handler: getOpportunityStages,
  },
  {
    method: 'post',
    path: '/api/opportunitystages',
    handler: postOpportunityStage,
  },
  {
    method: 'patch',
    path: '/api/opportunitystages/:id',
    handler: patchOpportunityStage,
  },
  {
    method: 'patch',
    path: '/api/opportunitystages',
    handler: patchOpportunityStages,
  },
  {
    method: 'delete',
    path: '/api/opportunitystages/:id',
    handler: deleteOpportunityStage,
  },
].map((h) => ({ ...h, ...{ handler: requireAuthenticatedUser(h.handler) } }))
